import * as Actions from '../../actions/register/index';

const initialState = true;

const navigation = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.SET_NAVIGATION:
        {
            return action.payload;
        }

        case Actions.REMOVE_NAVIGATION:
        {
            return initialState;
        }
        
        default:
        {
            return state;
        }
    }
}

export default navigation;